
const handleMouse = () => {
  let initialX, initialY, currentX, currentY, xOffset = 0, yOffset = 0;
  let prevSlide = 0;
  let active = false;
  let startTime = 0;
  let speed = 0, lastPositionY = 0;
  let container = $(".questions-slide-wrap")
  const dragItem = $(".questions-slide-wrap .slide")
  function dragStart(e) {
    if (e.type === "touchstart") {
      initialX = e.touches[0].clientX;
      initialY = e.touches[0].clientY;
    } else {
      initialX = e.clientX;
      initialY = e.clientY;
    }
    lastPositionY = initialY
    active = true;
    $slider.slick("slickSetOption", "speed", 200, false)


  }

  async function dragEnd(e) {
    if(active != true) return;
    
    prevSlide = 0;
    active = false;

    speed = Math.abs(lastPositionY - currentY) / ((Date.now() - startTime)) * 1000;
    let direction = lastPositionY - currentY > 0 ? "up" : "down";
    console.log("speed", speed)
    if (speed > 600) {
      let count = 0;
      $slider.slick("slickSetOption", "speed", 300, false)
      $answerSlider.slick("slickSetOption", "speed", 300, false)

      for (let i = 0; i < 6; i++) {
        $slider.slick(direction == "up" ? "slickNext" : "slickPrev");
        await new Promise(r => setTimeout(r, 350))
      }

    }
    $answerSlider.slick("slickSetOption", "speed", 500, false)
    $slider.slick("slickSetOption", "speed", 500, false)

  }

  function drag(e) {
    if (active) {
      e.preventDefault();

      if (e.type === "touchmove") {
        currentX = e.touches[0].clientX;
        currentY = e.touches[0].clientY;
      } else {
        currentX = e.clientX;
        currentY = e.clientY;
      }

      xOffset = currentX;
      yOffset = currentY;

      if (Date.now() - startTime > 500) {
        speed = Math.abs(lastPositionY - currentY) / ((Date.now() - startTime)) * 1000
        lastPositionY = currentY;
        startTime = Date.now()

      }

      //  console.log(initialY, currentY, initialY - currentY)
      let currentSlide = $slider.slick("slickCurrentSlide")
      let nextSlide = Math.ceil((initialY - currentY) / 50)
      if (nextSlide != prevSlide) {
        if (nextSlide < prevSlide) $slider.slick("slickPrev")
        else $slider.slick("slickNext")
        prevSlide = nextSlide;

      }

      //setTranslate(currentX, currentY, dragItem);
    }
  }

  function setTranslate(xPos, yPos, el) {
    el[0].style.transform = "translate3d(" + xPos + "px, " + yPos + "px, 0)";
  }

  function init() {
    container.on("touchstart", ".slick-list", dragStart);
    container.on("touchend", ".slick-list", (e) => dragEnd(e));
    container.on("touchmove", ".slick-list", drag);

    container.on("mousedown", ".slick-list", dragStart);
    container.on("mouseup mouseleave", ".slick-list", (e) => dragEnd(e));
    container.on("mousemove", ".slick-list", drag);
  }
  init();
}

export default handleMouse